import { render } from "./ProgramSelect.vue?vue&type=template&id=527c7e14&scoped=true"
import script from "./ProgramSelect.vue?vue&type=script&lang=js"
export * from "./ProgramSelect.vue?vue&type=script&lang=js"

import "./ProgramSelect.vue?vue&type=style&index=0&id=527c7e14&scoped=true&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527c7e14"]])

export default __exports__